import React from "react";
import { MdAddCircle } from "react-icons/md";
import history from "../../services/history";
import { useCallback, useContext, useEffect, useState } from "react";
import { Link, useLocation, useHistory, useParams } from "react-router-dom";
import { Context } from "../../context/AuthContext";
import api from "../../services/api";

import PrimaryButton from "../../components/Button/PrimaryButton";
import LoadingTable from "../../components/LoadingTable";
import SecondaryButton from "../../components/Button/SecondaryButton";
import InfoContext from "../../context/InfoContext";
import ProductTable from "../../components/Table/ProductTable";
import { ProductsProps } from "../../types/Products";

import { Pagination } from "../../components/Pagination";
import { QuestionChecklistProps } from "../../types/QuestionChecklist";
import QuestionsTable from "../../components/Table/QuestionsTable";

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function ExtraQuestions() {
    const [extraQuestion, setExtraQuestion] = useState<
        QuestionChecklistProps[]
    >([]);
    const { handleLogOut, user } = useContext(Context);
    const { reloadData, setReloadData } = useContext(InfoContext);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const query = useQuery();

    const product_id = query.get("product_id");

    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [limit, setLimit] = useState(1);
    const [totalRegister, setTotalRegister] = useState(1);

    const [groupSearch, setGroupSearch] = useState("");

    const cardsInfo = [
        {
            nameGroup: "grupo dep erguntas 1",
            questions: [
                "que dia é hoje?",
                "ta certo isso dai?",
                " um dois tres quatro seis?",
            ],
        },
        {
            nameGroup: "grupo dep erguntas 2",
            questions: [
                "uma pergunta?",
                "duas perguntas?",
                " tres perguntas?",
                "quarta pergunta?",
                "tres perguntas?",
                " seis perguntas?",
            ],
        },
        {
            nameGroup: "grupo dep erguntas 3",
            questions: ["só uma msm?"],
        },
    ];

    let { id }: { id: string } = useParams();

    const getExtraQuestion = useCallback(async () => {
        setExtraQuestion([]);
        try {
            const { data } = await api.get(
                `groups?name=${groupSearch}&page=${page}&limit=7`
            );

            setPage(data.currentPage);
            setLastPage(data.lastPage);
            setTotalRegister(data.totalRegister);
            setExtraQuestion(data.list);
            setIsLoading(true);
        } catch {
            handleLogOut();
        }
    }, [page]);

    useEffect(() => {
        getExtraQuestion();
    }, [id, reloadData, page]);

    return (
        <div>
            <div className="flex justify-between items-center">
                <h1 className="font-bold text-2xl">Perguntas</h1>
                <div className="flex gap-3">
                    <Link to={`/extraQuestionsAdd`}>
                        <PrimaryButton title="Cadastrar" />
                    </Link>
                </div>
            </div>

            {isLoading ? (
                <>
                    {extraQuestion.length ? (
                        <>
                            <QuestionsTable list={extraQuestion} />
                            <Pagination
                                totalPage={lastPage}
                                page={page}
                                setPage={setPage}
                                path={`groups`}
                            />
                        </>
                    ) : (
                        <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="py-16">
                                <div className="text-center">
                                    <p className="text-sm font-semibold text-indigo-600 uppercase tracking-wide"></p>
                                    <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                                        No momento não temos perguntas
                                        cadastradas
                                    </h1>
                                    <p className="mt-2 text-base text-gray-500"></p>
                                </div>
                            </div>
                        </main>
                    )}
                </>
            ) : (
                <LoadingTable />
            )}
        </div>
    );
}
